import { EventBus } from '@/app/shared/services/event-bus.js';
import localeEn from '@/app/pharmacy/locales/en'
import localeAr from '@/app/pharmacy/locales/ar'
import { showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';



export default {

    data() {
        return {
            hideNotification: 5000,
            notificationFlag:true,
            suffix: 'changing-cash',
            saveModel: {},
            CashModel: {},
            visitinfo: {},
            confirmdata: [
                {
                    confirmText: '',
                    confirmBtnBtnText: '',
                    cancelBtnText: '',
                    headerTitle: '',
                    messageText: '',
                    poptype: '',
                    itemName: '',
                    qmark: '',
                    popupclass: ''
                }
            ],
        }
    },
    props: [
        'msuffix'
    ],
    methods: {
        showPopupNotification,
        cancel() {
            this.$refs['pay-modal-ref'].hide();
            EventBus.$emit('CancelClicked', "");
        },


        BulkAssignCoverBtn() {
            if (this.notificationFlag) {

               // switch (this.notificationFlag) {
                // case parseInt(getSaveResultEnum().SavedSuccess):
                    this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('Common.SavedSuccessfully')}`, `success`);               
                //break;
        //        case parseInt(getSaveResultEnum().FailedToSave):
        //this.showPopupNotification(`${this.$i18n.t('Common.Failure')}`, `${this.$i18n.t('clinicalServices.AddedPage.faliedToster')}`, `error`);        
        //break;
              //  case parseInt(getSaveResultEnum().Concurrency):
        //this.showPopupNotification(`${this.$i18n.t('clinicalServices.AddedPage.concurrency')}`, `${this.$i18n.t('Common.Concurrency')}`, `warning`);
        //this.cancel();
       
        //break;

               // }
                   
 
            }
            
            this.$refs['pay-modal-ref'].hide(); 
        }
    },
    components: {
        showPopupNotification
    },
    
    mounted() {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();
    },
    
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
}
